/* ==========================================================================
   Header > Client > Cookie
   ========================================================================== */

const getCookie = cname => {
    const name = `${cname}=`;
    const splitCookie = document.cookie.split(';');
    for (let i = 0; i < splitCookie.length; i++) {
        let value = splitCookie[i];
        while (value.charAt(0) === ' ') {
            value = value.substring(1);
        }
        if (value.indexOf(name) === 0) {
            return value.substring(name.length, value.length);
        }
    }
    return '';
};

const setCookie = (cookieName, cookieValue, nDays) => {
    const today = new Date();
    const expire = new Date();

    let nDaysFinal = nDays;
    if (nDays === null || nDays === 0) {
        nDaysFinal = 1;
    }

    expire.setTime(today.getTime() + 3600000 * 24 * nDaysFinal);
    document.cookie = `${cookieName}=${cookieValue};expires=${expire.toGMTString()};path=/`;
};

module.exports = {
    getCookie,
    setCookie
};
